import { render, staticRenderFns } from "./productDeatail.vue?vue&type=template&id=0487254b&scoped=true&"
import script from "./productDeatail.vue?vue&type=script&lang=js&"
export * from "./productDeatail.vue?vue&type=script&lang=js&"
import style0 from "./productDeatail.vue?vue&type=style&index=0&id=0487254b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0487254b",
  null
  
)

export default component.exports